<rotec-modal-v2
  [title]="'MACHINE_Machine VALUE' | translate: { value: state.machine.name || '' }"
  [hideModalTitle]="true"
  [disablePaddingMainPart]="true"
  [darkMode]="true"
  width="80vw"
  height="95vh"
>
  <ng-container ngProjectAs="modal-main">
    <div class="sections">
      <section class="section left">
        <img
          alt="Machine Image"
          [class.emptyImg]="!state.machine.pictureId"
          [src]="state.machine.pictureId | rotecImageV2 | async"
        />
      </section>
      <section class="section right">
        <div class="content general">
          <h2 class="content-title">{{ state.machine.name }}</h2>
          <div class="row status-row">
            <p class="row-name" translate>COMMON_Serial Number</p>
            <div class="row-value">
              {{ state.machine.serial || '-' }}
            </div>
            @if (state.machine.realTwinId) {
              <rotec-chip-v2 class="chip" icon="check" [darkerGray]="true" [greenFont]="true"
                >Connected</rotec-chip-v2
              >
            } @else {
              <rotec-chip-v2
                class="chip not-connected"
                icon="close"
                [darkerGray]="true"
                [redIcon]="true"
                [pink-font]="true"
                >Not Connected</rotec-chip-v2
              >
            }
          </div>
          <div class="row">
            <p class="row-name" translate>COMMON_Manufacturer</p>
            <div class="row-value">{{ state.machine.manufacturer || '-' }}</div>
          </div>
          <div class="row">
            <p class="row-name" translate>PLANT_Plant</p>
            <div class="row-value">{{ state.plant.name || '-' }}</div>
          </div>
          <div class="row">
            <p class="row-name" translate>
              {{ 'In VALUE Groups' | translate: { value: state.machineGroups.length } }}
            </p>
            <div class="row-value">
              @for (machineGroup of state.machineGroups; track machineGroup) {
                <rotec-chip-v2 [darkGray]="true" [whiteFont]="true" class="chip">{{
                  machineGroup.name
                }}</rotec-chip-v2>
              }
            </div>
          </div>
        </div>
        <div class="main">
          <div class="content">
            <h4 class="content-title" translate>Details</h4>
            <div class="row">
              <p class="row-name" translate>MACHINE_CAB Type</p>
              <div class="row-value">{{ state.machine.cabType || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>MACHINE_CAB Version</p>
              <div class="row-value">{{ state.machine.cabVersion || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>MACHINE_PLC Type</p>
              <div class="row-value">{{ state.machine.plcType || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>MACHINE_PLC Version</p>
              <div class="row-value">{{ state.machine.plcVersion || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>MACHINE_HW Version</p>
              <div class="row-value">{{ state.machine.hwVersion || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>MACHINE_FW Version</p>
              <div class="row-value">{{ state.machine.fwVersion || '-' }}</div>
            </div>
            <div class="row">
              <p class="row-name" translate>COMMON_Inventory Number</p>
              <div class="row-value">{{ state.machine.inventoryNo || '-' }}</div>
            </div>
            <div class="row margin-top-40">
              <p class="row-name" translate>COMMON_Maintenance Contact</p>
              <div class="row-value">{{ state.machine.maintenanceContact || '-' }}</div>
            </div>

            <div class="row">
              <p class="row-name" translate>COMMON_Main Contact</p>
              <div class="row-value">{{ state.machine.mainContact || '-' }}</div>
            </div>
          </div>

          <ma-task-list
            [tasks]="state.tasks"
            (openTask)="openTask($event)"
            (deleteTask)="deleteTask($event)"
          ></ma-task-list>
        </div>
      </section>
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-primary-v2 dark (click)="modalRef.close()">
      {{ 'Close' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
